import { makeStylesV5 } from "..";
export default makeStylesV5()((theme) => ({
    coreSelectMenuPaper: {
        border: '1px solid #BBBBBB',
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        '& .MuiMenuItem-root': {
            whiteSpace: 'normal',
            '& .MuiCheckBox-root': {
                padding: 0,
                paddingRight: 10
            },
            '& .MuiListItemText-root': {
                '& .MuiTypography-root': {}
            },
            '&.sticky-option': {
                boxSizing: 'border-box',
                position: 'sticky',
                top: -1,
                zIndez: 1,
                backgroundColor: theme.palette.common.white,
                '&.Mui-selected': {
                    backgroundColor: theme.palette.common.white,
                    '&:hover': {
                        backgroundColor: theme.palette.common.white
                    }
                }
            },
        },
    }
}));
//# sourceMappingURL=styles.js.map